import { modifyState } from "../components/UiComponents/Buttons/BackButton/helper";
import history from "./history";
import { languagePrefix } from "./i18n";

export const navigateTo = (path, extraState = {}) => {
  history.push(linkBuilder(path), {
    ...modifyState(history, location.pathname),
    ...extraState,
  });
};

export const linkBuilder = (path) => {
  return `${languagePrefix()}${path}`;
};
